export const CdnConfig = Object.freeze({
  healisticIconSvg: 'https://static.healistic.net/icons/healistic-icon.svg',
});
